import { Injectable } from '@angular/core';

@Injectable()
export class LoggerService {

      public static debug(message: any) {
            console.debug(new Date() + ': ' + JSON.stringify(message));
      }

      public info(messageinfo: any, message?: any) {
            //console.log(new Date() + ': ' + messageinfo + JSON.stringify(message));
      }

}